import React from "react";
import {
  Grid,
  Segment,
  Modal,
  Button,
  Checkbox,
  Header,
  TextArea,
  Form,
  Divider
} from "semantic-ui-react";
import moment from "moment";
import Occupancy from "./Occupancy";
import { connect } from "react-redux";
import { isSynchronizing } from "../../users/selectors";
import { createOccupancy, editOccupancy } from "../occupancy/actions";
import { saveRoomNote } from "../../synchronization/actions";
import { isToday } from "../../utils/helpers/date";

const getSelectedRoom = (roomId, rooms) => {
  const room = rooms.find(room => room.roomId === roomId);

  return room || {};
};
const initialState = {
  arrival: {
    occur: false,
    personsAdult: 0,
    personsCategoryAge1: 0,
    personsCategoryAge2: 0,
    personsCategoryAge3: 0
  },
  stay: {
    occur: false,
    personsAdult: 0,
    personsCategoryAge1: 0,
    personsCategoryAge2: 0,
    personsCategoryAge3: 0
  },
  departure: {
    occur: false,
    personsAdult: 0,
    personsCategoryAge1: 0,
    personsCategoryAge2: 0,
    personsCategoryAge3: 0
  },
  note: "",
  status: undefined,
  date: undefined,
  roomId: undefined
};
class OccupancyModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
      date: props.date,
      roomId: props.roomId
    };
  }

  handleSave = () => {
    const { status, ...occupancy } = this.state;
    const room = getSelectedRoom(occupancy.roomId, this.props.rooms);
    if (isToday(this.props.date))
      this.props.socket.emit("room:change-status", { ...room, status });

    if (this.props.isSynchronizing) {
      const { arrival, stay, departure, ...roomNote } = occupancy;
      this.props.socket.emit("room:change-room-info", occupancy);
      this.props.saveRoomNote({ ...roomNote, date: moment.utc(roomNote.date) });
    } else if (occupancy.roomInfoId > 0) {
      this.props.editOccupancy({ ...occupancy, date: this.props.date });
      this.props.socket.emit("room:change-room-info", occupancy);
    } else {
      this.props.createOccupancy({
        ...occupancy,
        date: this.props.date
      });
    }
  };

  changeOccupancyField = (occupancy, field, value) => {
    this.setState(prevState => ({
      [occupancy]: { ...prevState[occupancy], [field]: value }
    }));
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.occupancy !== undefined) {
      const selectedRoom = getSelectedRoom(
        nextProps.occupancy.roomId,
        this.props.rooms
      );

      this.setState({
        ...initialState,
        ...nextProps.occupancy,
        status: selectedRoom.status
      });
    }
  }
  render() {
    const { props } = this;
    const selectedRoom = getSelectedRoom(this.state.roomId, this.props.rooms);
    return (
      <Modal open={props.visible} onClose={props.toggleModal}>
        <Modal.Header>
          {props.t("occupancy:header")} {selectedRoom && selectedRoom.name}
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <Segment basic>
              <Grid columns="equal" stackable>
                <Grid.Row>
                  <Grid.Column />
                  <Grid.Column width={6} textAlign="center">
                    <Header as="h3">
                      {props.t("occupancy:occupancyText")}
                    </Header>
                  </Grid.Column>
                  <Grid.Column />
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Occupancy
                      label={props.t("roomBlock:arrivalText")}
                      disabled={!props.isAdmin || props.isSynchronizing}
                      onFieldChange={this.changeOccupancyField}
                      occupancy="arrival"
                      t={props.t}
                      {...this.state.arrival}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Occupancy
                      label={props.t("roomBlock:stayText")}
                      disabled={!props.isAdmin || props.isSynchronizing}
                      onFieldChange={this.changeOccupancyField}
                      occupancy="stay"
                      t={props.t}
                      {...this.state.stay}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Occupancy
                      label={props.t("roomBlock:departureText")}
                      disabled={!props.isAdmin || props.isSynchronizing}
                      onFieldChange={this.changeOccupancyField}
                      occupancy="departure"
                      t={props.t}
                      {...this.state.departure}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column />
                  <Grid.Column width={6} textAlign="center">
                    <Header as="h3">{props.t("occupancy:notes")}</Header>
                  </Grid.Column>
                  <Grid.Column />
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Form>
                      <TextArea
                        onChange={e => this.setState({ note: e.target.value })}
                        value={this.state.note}
                      />
                    </Form>
                  </Grid.Column>
                </Grid.Row>
                {!props.future && (
                  <Grid.Row>
                    <Grid.Column />
                    <Grid.Column width={6} textAlign="center">
                      <Header as="h3">
                        {props.t("occupancy:cleaningStatus")}
                      </Header>
                    </Grid.Column>
                    <Grid.Column />
                  </Grid.Row>
                )}
                {!props.future && (
                  <Grid.Row>
                    <Grid.Column>
                      <Checkbox
                        toggle
                        name="status"
                        label={props.t("occupancy:clean")}
                        color="red"
                        onChange={() => this.setState({ status: undefined })}
                        checked={this.state.status == undefined}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Checkbox
                        toggle
                        name="status"
                        label={props.t("occupancy:cleaning")}
                        onChange={() => this.setState({ status: "cleaning" })}
                        checked={this.state.status === "cleaning"}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Checkbox
                        toggle
                        name="status"
                        label={props.t("occupancy:cleaned")}
                        onChange={() => this.setState({ status: "cleaned" })}
                        checked={this.state.status === "cleaned"}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Checkbox
                        toggle
                        name="status"
                        label={props.t("occupancy:dirty")}
                        onChange={() => this.setState({ status: "dirty" })}
                        checked={this.state.status === "dirty"}
                      />
                    </Grid.Column>
                  </Grid.Row>
                )}
              </Grid>
            </Segment>
          </Modal.Description>
          <Divider hidden />
          <Button
            color="blue"
            onClick={() => {
              this.handleSave();
              props.toggleModal();
            }}>
            {props.t("common:saveText")}
          </Button>
          <Button onClick={() => props.toggleModal()}>
            {props.t("common:cancelText")}
          </Button>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  rooms: state.rooms.data,
  isSynchronizing: isSynchronizing(state),
  socket: state.messages.socket,
  date: state.occupancy.date
});

const mapDispatchToProps = dispatch => ({
  createOccupancy: occupancy => {
    dispatch(createOccupancy(occupancy));
  },
  editOccupancy: occupancy => {
    dispatch(editOccupancy(occupancy));
  },
  saveRoomNote: note => {
    dispatch(saveRoomNote(note));
  }
});

export const OccupancyModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(OccupancyModalComponent);



// WEBPACK FOOTER //
// ./src/rooms/HotelStructure/OccupancyModal.js